module.exports = __webpack_public_path__ + "static/media/05coree.c38d0453.png";